import { Component, OnInit, Output, EventEmitter, Input, ViewChild, ElementRef } from '@angular/core';
import { TaskDataService,  } from '../../../../shared/services/task-data.service';
import { IPaymentMethod, ITaskRequest, ITaskVoucherData, TaskRequest, TaskVoucherData } from '../../../../modules/tasks/model/types';

import notify from 'devextreme/ui/notify';
import validationEngine from "devextreme/ui/validation_engine";
import { TreasuryDataService } from '../../../../shared/services/treasury-data.service';

import { filterLoanData, getNotificationTimeout, sendNotificationMessage } from '../../../../types/resource';
import { LoggingService } from '../../../../framework/logging/logging.service';
import { SeverityLevel } from '../../../../framework/logging/severity-level.model';
import { BehaviorSubject, lastValueFrom } from 'rxjs';

import { ProfileDataService } from '../../../../shared/services/profile-data.service';
import { MessageService } from '../../../../shared/components/framework/services/message.service';
import { FormUtils } from '../../../../shared/components/framework/services/form-builder.service';
import { LoanDataBase } from '../../baseclass/loandata-base';
import { set } from 'lodash';


@Component({
  selector: 'app-voucher',
  templateUrl: './voucher.component.html',
  styleUrls: ['./voucher.component.css']
})
export class VoucherComponent extends LoanDataBase implements OnInit {
  @ViewChild('formElement') formElement!: ElementRef;

  @Input() taskTemplateName: string;
  @Input() task?: ITaskRequest;

  @Output() onAddNewTaskEventEmitter: EventEmitter<any> = new EventEmitter();

  taskVoucherTypes: any[];
  isLoading: boolean = false;
  bankData: any[];
  voucherData:  ITaskVoucherData;
  billableToClientData: any[];
  businessDayCalendars: any[];
  files: File[] = [];
  directors: any[];
  seniorDirectors: any[];
  paymentMethods: IPaymentMethod[];
  paymentTypeDisabled: boolean = true;
  paymentTypeDisabledBehaviourSubject$ = new BehaviorSubject<boolean>(true);
  paymentTypeDisabled$ = this.paymentTypeDisabledBehaviourSubject$.asObservable();
  today: Date;
  isEditable: boolean = false;
  fileSelectionText: string;
  formItemsBehaviourSubject$ = new BehaviorSubject<any[]>([]);
  formItems$ = this.formItemsBehaviourSubject$.asObservable();
  formItems: any[] = [];
  currentFormInstance: any = null;


  constructor(
    taskDataService: TaskDataService,
    private readonly treasuryDataService: TreasuryDataService,
    private readonly profileDataService: ProfileDataService,
    private readonly messageService: MessageService,
    private readonly loggingService: LoggingService
  ) {
    super(taskDataService);
    this.onValidateSecondaryApprover = this.onValidateSecondaryApprover.bind(this);
    this.onRequestTypeSelectionChanged = this.onRequestTypeSelectionChanged.bind(this);
    this.onValidateFileAttachments = this.onValidateFileAttachments.bind(this);

    this.paymentTypeDisabled$.subscribe((value: boolean) => {
      this.paymentTypeDisabled = value;
    });

    this.formItems$.subscribe((items: any[]) => {
      this.formItems = items;
    });
  }

  onFileUpload(file: File)
  {
    this.files.push(file);
  }

  onFileRemove(file: File)
  {
    if(file != null && file != undefined)
    {
      this.files = this.files.filter(f => f !== file);
    }
  }

  onValidateVoucherAmount(e: any) : boolean
  {
    if(e.value == null || e.value <= 0)
      return false;

    return true;
  }

  onValidateFileAttachments(e: any) : boolean
  {
    if(this.files.length == 0 && !this.isEditable)
    {
      e.isValid = false;
      return false;
    }
    e.isValid = true;
    return true;
  }

  onValidateSecondaryApprover(e: any)
  {
    if(this.voucherData.voucherAmount > 10000000 && e.value == null)
    {
      return false;
    }

    return true;
  }

  removeLocationData(data: string): string
  {
    let json = JSON.parse(data);
    delete json['locations'];
    return JSON.stringify(json);
  }

  onRequestTypeSelectionChanged(e: any)
  {
    if (!e.selectedItem) return;

    const typeName = e.selectedItem.name.toUpperCase();
    const paymentDisabled = typeName !== 'THIRD PARTY - TAX' && typeName !== 'THIRD PARTY - INSURANCE';
    this.paymentTypeDisabledBehaviourSubject$.next(paymentDisabled);

    const config: any[] = [
      {
        dataField: "feesPaidToMS",
        editorType: "dxCheckBox",
        label: { visible: false },
        editorOptions: { text: "Include Fees Paid to MS" },
      },
      {
        dataField: "billableToClient",
        editorType: "dxCheckBox",
        label: { visible: false },
        editorOptions: { text: "Billable to Client" },
      },
      {
        dataField: "debitBank",
        editorType: "dxSelectBox",
        label: { text: "Debit Bank Name" },
        colSpan: 2,
        cssClass: "dx-widget",
        editorOptions: {
          items: this.bankData,
          valueExpr: "name",
          displayExpr: "name",
          required: "true",
          searchMode: "contains",
          searchEnabled: true,
        },
        validationRules: [{ type: "required", message: "Debit Bank is required" }],
      },
      {
        itemType: "group",
        colCount: 4,
        colSpan: 2,
        items: [
          {
            labelMode: "static",
            dataField: "loanNumber",
            editorType: "dxSelectBox",
            colSpan: 3,
            cssClass: "dx-widget",
            label: { text: "Loan Number" },
            editorOptions: {
              items: this.loanData,
              valueExpr: "name",
              displayExpr: "name",
              required: "true",
              searchMode: "contains",
              searchEnabled: true,
              itemTemplate: this.loanItemTemplate,
            },
            validationRules: [{ type: "required", message: "Loan Number is required" }],
          },
          {
            editorType: "dxCheckBox",
            label: { visible: false },
            cssClass: "loan-checkbox-center-align",
            editorOptions: {
              text: this.activeLoanCheckboxText,
              onValueChanged: this.onShowInactiveLoansChanged,
              value: false,
            },
          },
        ],
      },
      {
        dataField: "voucherAmount",
        editorType: "dxNumberBox",
        label: { text: "Voucher Amount" },
        colSpan: 2,
        editorOptions: {
          required: "true",
          format: "#,##0.##",
          min: 0,
          defaultValue: 0,
        },
        validationRules: [
          {
            type: "custom",
            message: "Voucher Amount must be greater than zero",
            validationCallback: (e: any) => this.onValidateVoucherAmount(e),
            reevaluate: true,
          },
        ],
      },
      {
        dataField: "paymentMethod",
        editorType: "dxRadioGroup",
        label: { text: "Payment Method" },
        colSpan: 2,
        editorOptions: {
          items: this.paymentMethods,
          valueExpr: "method",
          displayExpr: "text",
          layout: "horizontal",
          disabled: paymentDisabled,
        },
      },
      {
        dataField: "dueDate",
        editorType: "dxDateBox",
        label: { text: "Due Date" },
        colSpan: 2,
        editorOptions: { value: this.today },
        validationRules: [{ type: "required", message: "Due Date is required" }],
      },
      {
        colSpan: 2,
        horizontalAlignment: "center",
        itemType: "simple",
        name: "fileUpload",
        label: { text: this.isEditable ? "Upload Files" : "Upload Files *" },
        template: "fileUploadTemplate",
      },
      {
        dataField: "fileUploadProxy",
        colSpan: 2,
        itemType: "simple",
        label: { visible: false },
        editorType: "dxTextBox",
        editorOptions: {
          visible: false,
          value: this.files.length.toString(),
        },
        validationRules: [
          {
            type: "custom",
            message: "At least one file must be attached",
            validationCallback: (e: any) => this.onValidateFileAttachments(e),
            reevaluate: true,
          },
        ],
      },
      {
        colSpan: 2,
        horizontalAlignment: "left",
        cssClass: "borrow-submit",
        editorType: "dxButton",
        editorOptions: { text: "Submit", useSubmitBehavior: true },
      },
    ];

    this.formItemsBehaviourSubject$.next(config);
  }

  onFormContentReady(e: any): void
  {
    this.currentFormInstance = e.component;
  }

  async onSubmit(e: any)
  {
    e.preventDefault();

    let validationResult = validationEngine.validateGroup("formGroup");

    if (validationResult.isValid)
    {
      try
      {
        let request: ITaskRequest = new TaskRequest();
        request.templateId = this.taskVoucherTypes.find((t) => t.name == this.voucherData.requestType).id;

        request.name = this.voucherData.requestType;
        request.referenceName = this.voucherData.loanNumber;
        request.referenceType = 'Facility';
        request.dueDate = this.voucherData.dueDate;

        let formData: FormData = new FormData();
        formData.append('templateId', request.templateId);
        formData.append('locations', request.locations);
        formData.append('name', request.name);
        formData.append('referenceName', request.referenceName);
        formData.append('requestJsonData', JSON.stringify(this.voucherData));
        formData.append('referenceType', request.referenceType);
        formData.append('dueDate', request.dueDate.toDateString());

        if(this.isEditable)
          formData.append('parentId', this.task.parentId);

        this.files.forEach((f) => {formData.append('files', f, f.name)});

        this.isLoading = true;

        const response = await lastValueFrom(this.taskDataService.insertTaskAsFormData(formData));
        sendNotificationMessage(`${response[1].data[0].task.taskId} task created`, this.messageService);

        this.isLoading = false;

        this.formElement.nativeElement.reset();
        this.formElement.nativeElement.submit();
      }
      catch(err: any)
      {
        this.isLoading = false;
        this.loggingService.logError(err, SeverityLevel.Error);
        notify(err.message, 'error', getNotificationTimeout());
      }
    }
  }



  override async ngOnInit() {

    try
    {
      this.isLoading = true;

      await super.ngOnInit();

      this.getPaymentMethods();

      const typeData = await lastValueFrom(this.taskDataService.getTaskTemplatesByType(this.taskTemplateName));
      this.taskVoucherTypes = typeData[1];

      this.bankData = await lastValueFrom(this.treasuryDataService.getBanks());

      const directorsData = await lastValueFrom(this.profileDataService.getUsersByGroup(["Directors", "Senior Directors"]));
      this.directors = directorsData[1][0].users;
      this.seniorDirectors = directorsData[1][1].users; //revisit this

      this.today = new Date();

      this.isEditable = this.task != null ? true : false;

      if(this.isEditable)
      {
        this.voucherData = FormUtils.mapFromTask<TaskVoucherData>(this.task, TaskVoucherData);
        this.onRequestTypeSelectionChanged({ selectedItem: { name: this.voucherData.requestType } });
        // console.log(this.voucherData);
      }
      else
      {
        this.voucherData = new TaskVoucherData();
        this.voucherData.paymentMethod = 'Wire';
      }

      this.isLoading = false;
    }
    catch(err: any)
    {
      this.loggingService.logError(err, SeverityLevel.Error);
      this.isLoading = false;
      notify(err.message, 'error', getNotificationTimeout());
    }
  }

  getPaymentMethods()
  {
    this.paymentMethods = [
      { key: 1, text: 'Wire', method: 'Wire' },
      { key: 2, text: 'Check', method: 'Check' },
      { key: 2, text: 'E-Check', method: 'E-Check' }
    ];
  }


}
